import type { Project } from "@overmap-ai/common"

import { ProjectNameFilterDef } from "../defs/ProjectNameFilterDef"
import { FilterSchema } from "./FilterSchema"
import { createFilterDefConfig } from "./utils"

// TODO: this will provide more value when project fields are ready

export const projectFilterSchema = FilterSchema.create<Project>({
	filterDefs: [
		createFilterDefConfig({
			filterDef: new ProjectNameFilterDef(),
			accessorFn: (project) => project.name,
		}),
	],
})
